import { api } from "../utils/api";
import UserStore from "../utils/UserStore";
import { mergeBandOccurrenceTypes } from "../views/Refo/refoLetters";

function isBandOccurrenceCatalog() {
  if (String(UserStore.getCodColigada()) === "2") return true;
  return (
    typeof window !== "undefined" &&
    /band\.diario-homolog|diario\.colband/.test(window.location.hostname)
  );
}

/**
 * @param {string} searchText
 * @param {string} classId
 * @param {string|{limit?: number, skip?: number, tiposVinculo?: string}} [options]
 *   string = tiposVinculo (Smart Minutes); object = pagination and/or tiposVinculo
 */
const getTeachers = (searchText = "", classId = "", options = {}) => {
  const opts =
    typeof options === "string" ? { tiposVinculo: options } : options || {};
  const { limit, skip, tiposVinculo } = opts;

  return api
    .get("Academics/teachers", {
      params: {
        filter: {
          searchText,
          classId,
          tiposVinculo: tiposVinculo || undefined,
          externalData: UserStore.getUserExternalInfo(),
          ...(limit != null ? { limit, skip: skip || 0 } : {})
        }
      }
    })
    .then(response => response.data);
};

const getTeacher = async id => {
  const res = await api.get(`Academics/teachers/${id}`);
  return res.data;
};

const getClassesForTeacher = async codProf => {
  const res = await api.get(`Academics/teachers/${codProf}/classes`);
  return res.data;
};

const getSubjetcts = async () => {
  return api.get("ClassDiaryV1/subjects").then(response => response.data);
};

const getSchedule = async (start, end, userId) => {
  const res = await api.get(
    `Academics/teacher/schedule${userId ? `/${userId}` : ""}`,
    { params: { start, end } }
  );
  return res.data;
};

const getClasses = async ({
  search,
  limit,
  skip,
  series,
  searchDisciplines
} = {}) => {
  const res = await api.get("ClassDiaryV1/class", {
    params: {
      externalData: UserStore.getUserExternalInfo(),
      ...(search ? { search } : {}),
      ...(limit != null ? { limit, skip: skip || 0 } : {}),
      ...(series ? { series } : {}),
      ...(searchDisciplines ? { searchDisciplines: true } : {})
    }
  });
  return res.data;
};

const getStudentsForClass = async id => {
  const res = await api.get(`ClassDiaryV1/class/${id}/students`, {
    params: {
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return res.data;
};

const getScheduleForOccurrence = async (id, { date } = {}) => {
  const res = await api.get(`ClassDiaryV1/class/${id}/occurrences/schedule`, {
    params: {
      externalData: UserStore.getUserExternalInfo(),
      ...(date ? { date } : {})
    }
  });
  return res.data;
};

const getOccurrenceTypes = async (
  classId,
  idTurmaDisc = undefined,
  codDisc = undefined
) => {
  const res = await api.get(`ClassDiaryV1/occurrences/types`, {
    params: {
      idTurmaDisc,
      classId,
      codDisc,
      externalData: UserStore.getUserExternalInfo()
    }
  });
  const types = Array.isArray(res.data) ? res.data : [];
  return isBandOccurrenceCatalog() ? mergeBandOccurrenceTypes(types) : types;
};

const getOccurrence = async (
  idTurmaDisc,
  occurrenceDate,
  scheduleId,
  weekDay
) => {
  const res = await api.get(`ClassDiaryV1/occurrences`, {
    params: {
      idTurmaDisc,
      occurrenceDate,
      scheduleId,
      weekDay
    }
  });
  return res.data;
};

const saveOccurrence = async (occurrenceData, options = {}) => {
  const { classId, filter, sync = false } = options;

  if (sync) {
    const res = await api.post("ClassDiaryV1/occurrences", {
      externalData: UserStore.getUserExternalInfo(),
      occurrenceData,
      ...(classId != null ? { classId } : {})
    });
    return res.data;
  }

  const res = await api.post("ClassDiaryV1/occurrences/job", {
    externalData: UserStore.getUserExternalInfo(),
    occurrenceData,
    ...(classId != null ? { classId } : {}),
    ...(filter != null ? { filter } : {})
  });
  return res.data;
};

const occurrenceAttachments = async occurrenceId => {
  const res = await api.get("ClassDiaryV1/occurrencesAttachments", {
    params: {
      occurrenceId
    }
  });
  return res.data;
};

const getOccurrenceStages = async (classId, codPerlet, codDisc) => {
  const res = await api.get("ClassDiaryV1/stages", {
    params: {
      externalData: UserStore.getUserExternalInfo(),
      classId,
      codPerlet,
      codDisc
    }
  });
  return res.data;
};

const getOccurrenceAdvancedConfig = async () => {
  const res = await api.get("ClassDiaryV1/occurrences/advanced-config");
  return res.data || {};
};

const getClassOccurrenceHistory = async (classId, codPerlet) => {
  const res = await api.get(
    `ClassDiaryV1/class/${classId}/occurrences/history`,
    {
      params: {
        externalData: UserStore.getUserExternalInfo(),
        ...(codPerlet ? { codPerlet } : {})
      }
    }
  );
  return res.data;
};

export default {
  // //////////////////////////
  getTeachers,
  getTeacher,
  getClassesForTeacher,
  getSubjetcts,
  getSchedule,
  getClasses,
  getStudentsForClass,
  getScheduleForOccurrence,
  getOccurrenceTypes,
  getOccurrence,
  saveOccurrence,
  occurrenceAttachments,
  getOccurrenceStages,
  getOccurrenceAdvancedConfig,
  getClassOccurrenceHistory
};
